export const data = [

    {
    "Position":"Grand Knight",
    "Name":"Larry Kulp"
    
},

{
    "Position":"Chaplain",
    "Name":"Father John Wykes"
    
},
{
    "Position":"Deputy Grand Knight",
    "Name":"Bob Saville"
    
},
{
    "Position":"Chancellor",
    "Name":"Stephen Pennell"
},
{ 
    "Position":"Treasurer",
    "Name":"Kerry Miller"

},
{
    "Position":"Advocate",
    "Name":"Paul Dix"
}
,
{
    "Position":"Recorder",
    "Name":"Jim Schwegel"
},
{
    "Position":"Warden",
    "Name":"Andy Springman"
},
{
    "Position":"Inside Guard",
    "Name":"Don Williams"
}
,
{ 
    "Position":"Outside Guard",
    "Name":"Richard McCart"
},
{
    "Position":"Financial Secretary",
    "Name":"Joel Buesteton"
}
,
{ 
    "Position":"One Year Trustee",
    "Name":"Mark Vantrease"
},
{ 
    "Position":"Two Year Trustee",
    "Name":"Richard Ruedin"
},
{
    "Position":"Three Year Trustee",
    "Name":"Jeremy Russell"
},
{
    "Position":"Lecturer",
    "Name":"Don Ehrman"
},
{ 
    "Position":"District Deputy",
    "Name":"Jeff Lister"
}
];